import { Component, Input } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";
import { take } from 'rxjs/operators';
import { faPlugCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { SelectionModel } from "@angular/cdk/collections";
import { SceneMimeTypes } from "../mime-constants";
import { BlockBaseComponent } from "../block-base/block-base.component";
import { IBlockLabelsRecords } from "../block-constants";
import { mimeSwap } from "../../../../common";
import { actionRemoveSceneBlocks, actionSceneJumpLinked, actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import { CommonService, ContainerService, LocalStoreService, StoreSelectorsService } from "../../../../services";
import {ExperienceLevelType, ISceneItemsUpdate, ISchedule} from "../../../../interfaces";
import { DialogPopComponent } from "../../../../components/dialog-pop/dialog-pop.component";
import { Router } from '@angular/router';

@Component({
    selector: 'app-block-scene',
    templateUrl: './block-scene.component.html',
    styleUrls: ['./block-scene.component.scss']
})
export class BlockSceneComponent extends BlockBaseComponent {
    mimeTypes = [];
    mimeType = '';
    faPlugCircleCheck = faPlugCircleCheck;
    accessSceneKey = '0';
    selectionModel: SelectionModel<any>;
    accessMask: Array<string> = [];
    selectedSchedule: string;
    schedules: Array<ISchedule> = [];
    isMimeMainPlayer: boolean;
    isPlayerAssignable = false;
    isSceneTopPropsMode = false;
    nonSelectedSchedule;
    isNestedScene = false;
    nestedSceneLabel = '';
    nestedSceneSrc = '';
    themes = [];
    theme = '1';

    @Input() set sceneTopProps(v: boolean) {
        this.isSceneTopPropsMode = v;
    }

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        private containerService: ContainerService,
        public override dialog: MatDialog,
        private commonService: CommonService,
        private router: Router,
        protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector, dialog);
        this.theme = this.localStoreService.getStorageValConfig('theme');

        this.nonSelectedSchedule = {
            schedule_name: this.translocoService.translate('general.nonScheduled', {}, this.translocoService.getActiveLang()),
            schedule_id: '-1',
            active: false
        };

        Object.keys(SceneMimeTypes).forEach((k) => {
            this.mimeTypes.push(k);
        });
        this.themes = [
            {
                optionValue: "1000",
                optionsLabel: "Aeon (Desktop)"
            },
            {
                optionValue: "1010",
                optionsLabel: "Matal works (Desktop)"
            },
            {
                optionValue: "1020",
                optionsLabel: "Minimal (Desktop)"
            },
            {
                optionValue: "1060",
                optionsLabel: "Metal works"
            },
            {
                optionValue: "2070",
                optionsLabel: "Minimal"
            },
            {
                optionValue: "2080",
                optionsLabel: "Topcoat light"
            },
        ];
    }

    override preInit() {
        super.preInit();
        this.selectionModel = new SelectionModel<string>(true, [this.sceneId]);
        this.cod(
            this.storeSelector.getSchedules().subscribe((i_items: ISchedule[]) => {
                this.schedules = i_items;
                this.selectedSchedule = this.sceneItem?.$?.scheduleId && this.sceneItem?.$?.scheduleId !== '-1' ? this.sceneItem.$.scheduleId : this.nonSelectedSchedule.schedule_id;
            })
        );
        this.cod(
            this.storeSelector.getUserAccessMask().subscribe((v) => {
                this.accessMask = v;
                // this.accessSceneKey = this.sceneItem.$.accessKey;
            })
        );
        if (this.sceneItem.$.src) {
            this.isNestedScene = true;
            this.nestedSceneSrc = this.sceneItem.$.src;
            this.cod(
                this.storeSelector.getScene(this.sceneItem.$.src)
                    .pipe(take(1))
                    .subscribe((val) => {
                        this.nestedSceneLabel = val.Player.$.label;
                    })
            );
        }
    }

    changeAccessMask(v) {
        const sceneItemsUpdate: ISceneItemsUpdate = {
            sceneId: this.sceneId,
            sceneItemId: this.sceneId,
            values: [{
                key: "accessKey",
                value: v,
                storePath: "$"
            }]
        };
        this.dispatchSceneItemChanges(sceneItemsUpdate, false);
    }

    dropdownSchedulerChanged(v) {
        const sceneItemsUpdate: ISceneItemsUpdate = {
            sceneId: this.sceneId,
            sceneItemId: this.sceneId,
            values: [{
                key: "scheduleId",
                value: v.value,
                storePath: "$"
            }]
        };
        this.dispatchSceneItemChanges(sceneItemsUpdate, false);
    }

    togglePlayerAssignable(v) {
        const values = [{
            key: "mimeType",
            value: v.checked === true ? 'mainPlayer' : 'scene',
            storePath: "$"
        }];

        const sceneItemsUpdate: ISceneItemsUpdate = {
            sceneId: this.sceneId,
            sceneItemId: this.sceneId,
            values
        };
        this.dispatchSceneItemChanges(sceneItemsUpdate, false);
    }

    override submit(formValues) {
        const storeMimeLong = this.sceneItem.$.mimeType;

        /** 4-11-2020 removed ability to change mime per scene, UNCOMMENT to bring back **/
        // const storeMimeShort = mimeSwap("longToShort", storeMimeLong);
        // const formMime = formValues.mimeType;

        /** 4-11-2020 removed ability to change mime per scene, COMMENT the following 3 lines to bring back **/
        formValues.mimeType = storeMimeLong;
        super.submit(formValues);

        if (!this.isNestedScene && formValues.label) {
            // update scheduler event value with new scene name
            this.commonService.updateScheduleEventValue('scene', [this.sceneId], formValues.label);
        }
        return;

        /** 4-11-2020 removed ability to change mime per scene, UNCOMMENT all the following lines to bring back **/
        //
        // /** no mime changed (other props have been modified) so keep mime as is **/
        // if (storeMimeShort === formMime || _.isUndefined(storeMimeLong) && formMime === 'None') {
        //     formValues.mimeType = storeMimeLong;
        //     super.submit(formValues);
        //     return;
        // }
        //
        // /** from a currently set mime in store to None **/
        // if (storeMimeLong && formMime === 'None') {
        //     const dialogRef = this.dialog.open(DialogPopComponent, {
        //         height: '300px',
        //         width: '600px',
        //         data: {name: `warning: are you sure you want to remove scene type? all related items will be removed, continue?`, showCancel: true}
        //     });
        //     this.cancelOnDestroy(
        //         dialogRef.afterClosed().subscribe(result => {
        //             if (!result) {
        //                 /** user changed mind, restore previous value **/
        //                 const originalShort = mimeSwap("longToShort", storeMimeLong);
        //                 this.setFormValue('mimeType', originalShort);
        //                 formValues.mimeType = storeMimeLong;
        //                 return super.submit(formValues);
        //             } else {
        //                 this.setFormValue('mimeType', 'None');
        //                 delete formValues.mimeType;
        //                 this.removeJsonItemsFromScene();
        //                 return super.submit(formValues);
        //             }
        //         })
        //     );
        //     return;
        // }
        //

        // /** from a currently set mime in store to another real mime type in form **/
        // if (!_.isUndefined(storeMimeShort) && formMime !== storeMimeShort) {
        //     const dialogRef = this.dialog.open(DialogPopComponent, {
        //         height: '300px',
        //         width: '600px',
        //         data: {name: `warning: are you sure you want to switch to a new scene type? all related items will be removed, continue?`, showCancel: true}
        //     });
        //     this.cancelOnDestroy(
        //         dialogRef.afterClosed().subscribe(result => {
        //             if (!result) {
        //                 /** user changed mind, restore previous value **/
        //                 const originalShort = mimeSwap("longToShort", storeMimeLong);
        //                 this.setFormValue('mimeType', originalShort);
        //                 formValues.mimeType = storeMimeLong;
        //                 return super.submit(formValues);
        //             } else {
        //                 formValues.mimeType = mimeSwap("shortToLong", formMime);
        //                 this.removeJsonItemsFromScene();
        //                 return super.submit(formValues);
        //             }
        //         })
        //     );
        //     return;
        // }
        //
        // /** from None to a mime type **/
        // if (_.isUndefined(storeMimeShort) && formMime) {
        //
        //     const dialogRef = this.dialog.open(DialogPopComponent, {
        //         height: '300px',
        //         width: '600px',
        //         data: {name: `warning: are you sure you want to switch to a new scene type? all related items will be removed, continue?`, showCancel: true}
        //     });
        //     this.cancelOnDestroy(
        //         dialogRef.afterClosed().subscribe(result => {
        //             if (!result) {
        //                 /** user changed mind, restore previous value **/
        //                 this.setFormValue('mimeType', 'None');
        //                 return super.submit(formValues);
        //             } else {
        //                 formValues.mimeType = mimeSwap("shortToLong", formMime);
        //                 this.removeJsonItemsFromScene();
        //                 return super.submit(formValues);
        //             }
        //         })
        //     );
        //     return;
        //
        //     // formValues.mimeType = mimeSwap("shortToLong", formMime);
        //     // return super.submit(formValues);
        //     // return;
        // }
    }

    override componentInit() {
        super.componentInit();
        if (this.sceneItem.$.mimeType) {
            /** 4-11-2020 removed ability to change mime per scene, UNCOMMENT to bring back **/
            // this.setUiConfigValue('mimeType', mimeSwap("longToShort", mimeType));
        } else {
            /** 4-11-2020 removed ability to change mime per scene, UNCOMMENT to bring back **/
            // this.setUiConfigValue('mimeType', 'None');
        }
    }

    override componentStoreUpdates() {
        if (this.sceneItem.$.mimeType === 'mainPlayer' && this.isSceneTopPropsMode) {
            this.setUiConfigHide('label', true);
            this.setUiConfigHide('defaultDuration', true);
            this.setUiConfigHide('id', false);
            this.setUiConfigHide('src', false);
            this.setUiConfigHide('mode', false);
            this.setUiConfigHide('key', false);
        } else {
            this.setUiConfigHide('label', false);
            this.setUiConfigHide('defaultDuration', false);
            this.setUiConfigHide('id', true);
            this.setUiConfigHide('src', true);
            this.setUiConfigHide('mode', true);
            this.setUiConfigHide('key', true);
        }
        super.componentStoreUpdates();
        this.mimeType = mimeSwap("longToShort", this.sceneItem.$.mimeType);
        this.isMimeMainPlayer = this.sceneItem.$?.mimeType === SceneMimeTypes.Player || this.sceneItem.$?.mimeType === SceneMimeTypes.Scene || this.sceneItem.$?.mimeType?.length === 0;
        this.isPlayerAssignable = this.sceneItem.$?.mimeType === SceneMimeTypes.Player || this.sceneItem.$?.mimeType?.length === 0;
        super.initApplyStoreToDynamic(true);

        // console.log("---------------block-scene-update");
        // this.assignIcon(this.sceneItem.$.mimeType);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
        // {
        //     type: "select",
        //     label: this.translocoService.translate('general.sceneType', {}, this.translocoService.getActiveLang()),
        //     name: "mimeType",
        //     value: "Tech",
        //     options: this.mimeTypes,
        //     storePath: '$.mimeType'
        // },
            {
                type: "input",
                value: 'scene',
                label: this.translocoService.translate('general.label', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                restrictChar: 'basic2',
                storePath: '$.label'
            },
            {
                type: "checkbox",
                value: '0',
                label: this.translocoService.translate('general.kioskMode', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "mode",
                storePath: 'Metadata[0].Kiosk[0].$.mode'
            },
            {
                type: "input",
                value: 'password',
                label: this.translocoService.translate('general.kioskExitPassword2', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "key",
                restrictChar: 'basic2',
                storePath: 'Metadata[0].Kiosk[0].$.key'
            },
            /*
            {
                    type: "input",
                    value: "10",
                    label: this.translocoService.translate('general.defaultDuration', {}, this.translocoService.getActiveLang()),
                    inputType: "number",
                    name: "defaultDuration",
                    storePath: 'Data[0].Scene[0].$.defaultDuration'
            },
             */
            {
                type: "select",
                label: this.translocoService.translate('general.theme', {}, this.translocoService.getActiveLang()),
                name: "id",
                value: "1000",
                options: this.themes,
                hideMe: true,
                storePath: 'Metadata[0].Theme[0].$.id'
            },
            {
                type: "select",
                label: this.translocoService.translate('general.softKeyboard', {}, this.translocoService.getActiveLang()),
                name: "src",
                value: "",
                options: [],
                observable: this.storeSelector.listenSceneOptions(),
                optionValue: "id",
                optionLabel: "label",
                defaultOption: {value: '', label: 'None'},
                storePath: 'Metadata[0].SoftKeyboard[0].Player[0].$.src'
            }
        ];

        if (this.isNestedScene) {
            delete this.uiConfigInit[0].storePath;
            // delete this.uiConfigInit[1].storePath;
        }
    }

    // assignIcon(i_blockPlayerId) {
    //     this.blockIcon = getFontIcons({$: {id: i_blockPlayerId}});
    // }

    removeJsonItemsFromScene() {
        this.sceneItem.Data[0].Scene[0].Players[0].Player.forEach((i_sceneItem) => {
            if (!this.storeSelector.isBlockIdJsonItemBased(i_sceneItem.$.player)) return;
            this.storeSelector.dispatch(actionRemoveSceneBlocks({
                    sceneId: this.sceneId,
                    sceneItemId: null,
                    values: [{
                        key: null,
                        value: i_sceneItem.$.id,
                        storePath: 'Data[0].Scene[0].Players[0].Player'
                    }]
                })
            );
        });
    }

    linkToNestedScene() {
        if (!this.nestedSceneSrc) return;
        this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.sceneId}));
        this.router.navigateByUrl(`/editor/scene/${this.nestedSceneSrc}`);
    }

    async convertAssignable() {
        const msg = this.translocoService.translate('message.sureConvert', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: msg, showCancel: true}
        });
        dialogRef.afterClosed().subscribe(async (r) => {
            if (r) {
                this.storeSelector.dispatch(actionUpdateSceneItem({
                    sceneId: this.sceneItem.$.id,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'mimeType',
                        value: SceneMimeTypes.Player,
                        storePath: '$'
                    }],
                    disableCRUD: true
                }));
            }
        });
    }

}

